import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 25rem;
  height: 8.75rem;
  margin: calc(50vh - 4.375rem) auto 0 auto;
  padding: 1.75rem 2rem;
  border-radius: 12px;
  background: ${({ theme }) => theme.tokens.colors.neutral['100']};
  box-shadow: 0px 40px 60px -15px rgba(0, 0, 0, 0.4);
`;

export const Text = styled.div`
  margin-bottom: 1.75rem;
  color: ${({ theme }) => theme.tokens.colors.text['100']};
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.5rem;
`;

export const ButtonsHolder = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: center;

  button {
    min-width: 6.75rem;
  }
`;
